/**
 * Shared build of the lock badge's holder name, so the PA (`usePATable`) and intake
 * (`intakeFeedRow`) feeds render the same holder identically. Pure module — no app imports — to
 * avoid circular deps.
 */
/** The holder's display name, or `null` when there is no holder or no usable name. */
export function lockHolderName(lock) {
    const holder = lock?.user;
    if (!holder)
        return null;
    return `${holder.firstName ?? ""} ${holder.lastName ?? ""}`.trim() || null;
}
